import * as React from 'react';

import { Container, Title, Section } from '../../modules/modules';
import ExternalBlogHelper, { IBlogPreviewContent } from 'helpers/src/externalBlog';
import './externalBlog.scss';
import * as moment from 'moment';

interface IExternalBlogProps {
    blogTags?: string[] | null;
    articleCountShow?: number | null;
    blogPreview?: IBlogPreviewContent[];
}

interface IExternalBlogState {
    blogPreview?: IBlogPreviewContent[];
}

export class ExternalBlog extends React.Component<IExternalBlogProps, IExternalBlogState> {
    componentDidMount(): void {
        if (!this.props.blogPreview && Array.isArray(this.props.blogTags)) {
            const externalBlog = new ExternalBlogHelper();
            externalBlog.getPreviewBlogContentsByTags(this.props.blogTags).then((preview) => {
               this.setState({blogPreview: preview.sort((a, b) => b.date.getTime() - a.date.getTime())});
            }
            );
        }
    }

    render() {
        if (!this.props.blogPreview) {
            if ('string' !== typeof process.env.REACT_APP_EXTERNAL_BLOG_GRAPHQL) {
                return null;
            }

            if (!Array.isArray(this.props.blogTags) || this.props.blogTags.length < 1) {
                return null;
            }
        }
        if ('number' === typeof this.props.articleCountShow && this.props.articleCountShow === 0) {
            return null;
        }

        if ((!this.state || !Array.isArray(this.state.blogPreview) || this.state.blogPreview.length < 1)
            && (!this.props.blogPreview || !Array.isArray(this.props.blogPreview) || this.props.blogPreview.length < 1)) {
            return null;
        }

        const handleImgError = (event: React.SyntheticEvent<HTMLElement, Event>, url: string) => {
            (event.target as HTMLImageElement).src = url;
        };

        const blogPreview = this.props.blogPreview || this.state.blogPreview || [];

        return (
            <Section type="blog-articles">
                <Container>
                    <div className="recommended_products blogPreview">
                        <Title type="center">BLOG</Title>
                        <div className="blogArticleWrapper">
                            {('number' === typeof this.props.articleCountShow && this.props.articleCountShow > -1
                                ? blogPreview.slice(0, this.props.articleCountShow)
                                : blogPreview
                            )
                                .map((preview: IBlogPreviewContent, index) => {
                                const imageFileUrl = `${process.env.REACT_APP_EXTERNAL_BLOG_IMAGE_PREFIX}${preview.image?.category}${preview.image?.hash}_${preview.image?.filename}`;
                                const lastDot = imageFileUrl.lastIndexOf('.');
                                const resizedImageFileUrl = lastDot > 0 ? `${imageFileUrl.substring(0, lastDot)}_600_300.${imageFileUrl.substring(lastDot + 1)}` : imageFileUrl;
                                const webPImageFileUrl = lastDot > 0 ? `${imageFileUrl.substring(0, lastDot)}_600_300.webp` : imageFileUrl;
                                const blogArticleURL = 'string' === typeof process.env.REACT_APP_EXTERNAL_BLOG_URL_PREFIX && preview.url
                                    ? `${process.env.REACT_APP_EXTERNAL_BLOG_URL_PREFIX}${preview.url}`
                                    : undefined;

                                return (
                                    <div key={preview.url} className="blogArticle smallerFonts">
                                        {blogArticleURL && <a className="linkOverlay" href={blogArticleURL} />}
                                        {preview.image && <div className={index < 3 ? '∭' : '' }>
                                                <picture>
                                                    <source srcSet={webPImageFileUrl} media="image/webp" />
                                                    <img src={resizedImageFileUrl} onError={(e) => handleImgError(e, imageFileUrl)}/>
                                                </picture>
                                            </div> || ''}
                                        <div className="blogArticle__content">
                                            {preview.date && <p className="blogArticle__content__date">{moment(preview.date).format('L')}</p>}
                                            {preview.title && <h4>{preview.title}</h4>}
                                            {blogArticleURL && <a href={blogArticleURL}>Read article</a>}
                                        </div>

                                    </div>
                                );
                            })}
                        </div>
                    </div>
                </Container>
            </Section>);
    }
}


// WEBPACK FOOTER //
// ./src/components/ExternalBlog/ExternalBlog.tsx